module.exports = __webpack_public_path__ + "img/icon9.a106a483.png";